import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `type-preview-serif` only sets the family, so it merges like `font-serif`, not like a size.
const TYPE_FAMILY_ONLY = new Set(["preview-serif"]);
const TYPE_UTILITY = /^(display|heading|title|body|label|subtitle|caption|code|preview)(-|$)/;

// A later `type-*` utility replaces an earlier one, and it conflicts with raw size and
// line-height classes the same way `text-lg` does. Tracking still composes, as with `text-lg`.
const twMerge = extendTailwindMerge<"type-scale">({
  extend: {
    classGroups: {
      "type-scale": [
        { type: [(value: string) => TYPE_UTILITY.test(value) && !TYPE_FAMILY_ONLY.has(value)] },
      ],
      "font-family": [{ type: [(value: string) => TYPE_FAMILY_ONLY.has(value)] }],
    },
    conflictingClassGroups: {
      "type-scale": ["font-size", "leading"],
      "font-size": ["type-scale"],
    },
  },
});

// eslint-disable-next-line
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
